class SiteHeader extends HTMLElement {
	constructor() {
		super();

    let collapsed = false;
    let template = this.dataset.template;
    let isBundle = template === 'product.bundle3d' || template === 'product.bundle-table';
    let collapsePoint = (template === "index" ||  isBundle || template === "collection") ? 580 : 200;
		if (template.includes('collection')) collapsePoint = 180;
		if (template.includes('article')) collapsePoint = 50;

    if (template.includes('catalogue')) {
      collapsePoint = 0;
      this.classList.add('collapsed');
    }

    let target = isBundle ? document.body : window;
    let scrollPos = isBundle ? () => document.body.scrollTop : () => window.scrollY;

    if (isBundle) this.classList.add('no-animation');
    let scrollPadding = 10;
    let prevScrollPos = 0;
    window.collectionScrollOffset = -180 - scrollPadding;

		const observer = new ResizeObserver(entries => {
			document.documentElement.style.setProperty('--header-height', `${this.offsetHeight.toFixed(0)}px`);
		});
		
		observer.observe(this);

    target.addEventListener('scroll', e => {
			if (document.body.classList.contains('enable-immersive-nav')) {
				if (scrollPos() < 20) document.body.classList.add('immersive-nav');
				else if (scrollPos() > 40) document.body.classList.remove('immersive-nav');
			}
			
      if (window.ssScrolling) {
        prevScrollPos = scrollPos();
        return;
      }
      if (window.innerWidth < 1260) {
        return;
      }
      if (document.body.classList.contains('ss-ac-open') || document.body.classList.contains('bundle-started')) return;
      if (scrollPos() > collapsePoint && !collapsed) {
        collapsed = true;
        this.classList.add('collapsed');
        document.documentElement.style.setProperty('--header-height', '107px');
        window.collectionScrollOffset = -130 - scrollPadding;
      }
      else if (scrollPos() < prevScrollPos - 5 & (scrollPos() < collapsePoint - 50 || scrollPos() <= 10) && collapsed) {
        collapsed = false;
        this.classList.remove('collapsed');
        document.documentElement.style.removeProperty('--header-height');
        window.collectionScrollOffset = -180 - scrollPadding;
      }
      prevScrollPos = scrollPos();
    }, { passive: true });

		if (document.body.classList.contains('enable-immersive-nav')) {
			this.addEventListener('mouseover', e => {
					if (window.innerWidth >= 1260) document.body.classList.remove('immersive-nav')
				}
			);
			this.addEventListener('mouseout', e => {
					if (window.innerWidth >= 1260 && scrollPos() < 20) document.body.classList.add('immersive-nav')
				}
			);
		}
	}
}

class SiteNav extends HTMLElement {
	constructor() {
		super();
		this.querySelector('button[name="open-nav"]').addEventListener('click', e => this.open());
		this.querySelector('button[name="open-nav"]').disabled = false;
		this.addEventListener('click', e => {
			if (e.target == this) this.close();
		});

		this.closest('.shopify-section').addEventListener('shopify:section:select', e => {
			this.dataset.state = 'open';
		});

		this.closest('.shopify-section').addEventListener('shopify:section:deselect', e => {
			this.dataset.state = 'closed';
		});

		this.addEventListener('shopify:block:select', e => {
			if (window.innerWidth < 1260) return;
			e.target.closest('site-header').classList.remove('secondary-content-open');
			e.target.classList.add('active');
		});

		this.addEventListener('shopify:block:deselect', e => {
			e.target.classList.remove('active');
		});

		if (!customElements.get('journal-toggle')) customElements.define('journal-toggle', JournalToggle);
		if (!customElements.get('nav-item')) customElements.define('nav-item', NavItem);
		if (!customElements.get('brand-toggle')) customElements.define('brand-toggle', BrandToggle);
		if (!customElements.get('nav-category-toggle')) customElements.define('nav-category-toggle', NavCategoryToggle);
	}

	open() {
		this.dataset.state = 'in';
		setTimeout(() => this.dataset.state = 'open', 300);
		document.documentElement.classList.add('nav-open');
	}

	close() {
		if (this.dataset.state != 'open') return;
		this.dataset.state = 'out';

		setTimeout(() => {
			this.querySelector('.site-nav__content').scrollTop = 0;
			this.dataset.state = 'closed';
			for (let navItem of this.querySelectorAll('nav-item:not(.nav-item--featured).active')) navItem.close();
		}, 300);

		document.documentElement.classList.remove('nav-open');
	}
}

class JournalToggle extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('mouseenter', e => {
			let items = this.closest('ul').querySelectorAll('li');
			items.forEach(item => item.classList.remove('active'));

			this.closest('li').classList.add('active');
			this.closest('.nav-content').querySelectorAll('.nav__featured-items').forEach(item => item.style.display = 'none');
			this.closest('.nav-content').querySelector(`.nav__featured-items[data-id="${this.dataset.id}"]`).style.display = '';
		});

		if (this.dataset.tags) this.tags = JSON.parse(this.dataset.tags);

		// Load when visible
		const observer = new IntersectionObserver(entries => {
			if (entries.some(entry => entry.isIntersecting)) {
				this.load();
				observer.disconnect();
			}
		});

		observer.observe(this);
	}

	async load() {
		if (!this.dataset.id || !this.tags) return;
		let resp = await fetch(`/blogs/journal/tagged/${this.tags.join('+')}?view=megamenu`);
		let data = await resp.text();
		this.closest('.nav-content').querySelector(`.nav__featured-items[data-id="${this.dataset.id}"]`).innerHTML = data;
	}
}

class BrandToggle extends HTMLElement {
	constructor() {
		super();
		
		this.addEventListener('mouseenter', e => {
			let items = this.closest('ul').querySelectorAll('li');
			items.forEach(item => item.classList.remove('active'));

			this.closest('li').classList.add('active');
			this.closest('.nav-content').querySelectorAll('.desktop-nav__brand-content').forEach(item => item.style.display = 'none');
			this.closest('.nav-content').querySelector(`.desktop-nav__brand-content[data-id="${this.dataset.id}"]`).style.display = '';
		});
	}
}

class NavCategoryToggle extends HTMLElement {
	constructor() {
		super();

		let buttons = this.querySelectorAll('button');
		
		for (let button of buttons) {
			button.addEventListener('click', e => {
				buttons.forEach(btn => btn.classList.remove('active'));
				button.classList.add('active'); 

				for (let items of this.parentElement.querySelectorAll(':scope > [data-category]')) {
					if (items.dataset.category == button.name) items.style.display = '';
					else items.style.display = 'none';
				}
			});
		}
	}
}

class NavItem extends HTMLElement {
	constructor() {
		super();

		this.contentTop = 0;

		this.content = this.querySelector('.nav-content');
		this.link = this.querySelector('.nav__link');
		this.location = this.dataset.location;
		this.type = this.dataset.type;
		this.secondary = this.location == 'secondary';

		if (this.content) {
			this.link.addEventListener('click', e => {
				if (window.innerWidth < 1260) {
					if (this.type == 'journal') return;
					else e.preventDefault();
				}
				if (this.classList.contains('active')) this.close();
				else this.open();
			});

			if (this.type == 'featured' && this.classList.contains('inline') && window.innerWidth < 1260) this.open();

			this.addEventListener('click', e => {
				if (e.target == this.content && this.type == 'country-selector') this.close();
			});
		}

		let back = this.querySelector('button[name="back"]');
		if (back) back.addEventListener('click', e => this.close());

		this.closeOnClickOut = e => {
			if (window.innerWidth < 1260) return;
			if (!this.contains(e.target)) {
				this.close();
			}
		}

		this.closeOnMoveOut = e => {
			if (window.innerWidth < 1260) return;
			if (this.content) {
				if (e.clientY > this.contentTop + this.content.offsetHeight + 10) this.close(e);		
			}
			else if (!this.matches(':hover')) this.close();
		}
	}

	open() {
		if (this.classList.contains('active')) return;
		this.classList.add('active');

		const parentContent = this.closest('.nav-content');
		if (parentContent) {
			parentContent.classList.add('no-scroll');
			this.style.setProperty('--top', `${parentContent.scrollTop}px`)
		}

		if (this.content && this.secondary) this.closest('site-header').classList.add('secondary-content-open');

		this.classList.add('transition-in');
		setTimeout(() => this.classList.remove('transition-in'), 300);

		setTimeout(() => {
			this.contentTop = this.content ? this.content.getBoundingClientRect().top : 0;
			window.addEventListener('click', this.closeOnClickOut, { capture: true });
			window.addEventListener('mousemove', this.closeOnMoveOut);
		});
	}

	close() {
		window.removeEventListener('click', this.closeOnClickOut, { capture: true });
		window.removeEventListener('mousemove', this.closeOnMoveOut);

		if (!this.classList.contains('active')) return;
		this.classList.remove('active');

		const parentContent = this.closest('.nav-content');
		if (parentContent) parentContent.classList.remove('no-scroll');
		this.style.removeProperty('--top');

		if (this.content && this.secondary) this.closest('site-header').classList.remove('secondary-content-open');

		this.classList.add('transition-out');
		setTimeout(() => this.classList.remove('transition-out'), 300);
	}
}

if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
if (!customElements.get('site-nav')) customElements.define('site-nav', SiteNav);